import { AnchorPointStopMarker } from '../../../../../mapComponents/Markers';
import { getRouteStopMarkerProps } from '../../../../../mapComponents/mapHelper';

const legendItems = (theme) => [
  {
    key: 'Assigned',
    label: 'Assigned Anchor',
    data: { anchorPointName: 'Assigned Anchor' },
    isDisabled: false
  },
  {
    key: 'Unassigned',
    label: 'Unassigned Anchor',
    data: { anchorPointName: 'Unassigned Anchor' },
    isDisabled: true
  },
  {
    key: 'AnchorStop',
    label: 'Anchor Stop',
    data: { anchorPointName: 'Anchor Stop' },
    markerColor: theme.AnchorBGColor,
    marker: AnchorPointStopMarker,
    ...getRouteStopMarkerProps({
        stopData: {},
        borderColor: theme.routeMapColorPalette.MarkerBorderColor,
        markerTextColor: theme.AnchorTextColor,   
        color: theme.AnchorBGColor,
        theme
      })
  }
];

export { legendItems };
